import { render } from "./PasswordChangeFormDialog.vue?vue&type=template&id=5e8d6ca7"
import script from "./PasswordChangeFormDialog.vue?vue&type=script&lang=js"
export * from "./PasswordChangeFormDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__